import { services } from '@comall-backend-builder/core';
import { ApiRequestConfig } from '@comall-backend-builder/core/lib/services/api';

const api = services.api;

// 特殊标签列表
export const ProductGoodsSalesTagSelect = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/products/specialList';
        const response: any = await api.get(params, config);
        const result: any = [];
        response.map((item: any) => {
            result.push({
                id: typeof item.id === 'number' ? item.id.toString() : item.id,
                name: item.value,
            });
        });
        return result;
    },
};
